import {DesktopFooter} from "./DesktopFooter";
import {useMediaQuery} from "@chakra-ui/react";
import {MobileFooter} from "./MobileFooter";

const Footer = () => {
    const [isMobile] = useMediaQuery("(max-width: 780px)");

    return (
        !isMobile ? <DesktopFooter /> : <MobileFooter />
    )
}

export default Footer